import { useEffect } from 'react';
import usePersistFn from '../usePersistFn';
import { isFunction } from '../utils';

var useUnmount = function useUnmount(fn) {
  var fnPersist = usePersistFn(fn);
  useEffect(function () {
    return function () {
      if (isFunction(fnPersist)) {
        fnPersist();
      }
    };
  }, []);
};

export default useUnmount;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useUnmount/index.js
// module id = 177
// module chunks = 2